import React from 'react';
import classnames from 'classnames';

import ProgressBar from '@wix/da-ds/pkg/ProgressBar';
import Loader from '@wix/da-ds/pkg/Loader';

import s from './DropZoneProgressBar.scss';

export interface Props {
  className?: string;
  label?: string;
  progress?: number;
}

const DropZoneProgressBar: React.FC<Props> = ({ className, label, progress }) => {
  return (
    <div className={classnames(s['root'], className)}>
      <Loader size="big" state="eating" />
      {progress && <ProgressBar progress={progress} className={s['progress-bar']} />}
      {label && <div className={s['progress-title']}>{label} </div>}
    </div>
  );
};
DropZoneProgressBar.displayName = 'DropZoneProgressBar';

export default DropZoneProgressBar;
